import React, { useState, useEffect } from 'react';

const Header = () => {
  const [activeSection, setActiveSection] = useState('hero');
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
      
      // Determine active section based on scroll position
      const sections = ['hero', 'services', 'about', 'contact'];
      const current = sections.find(section => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });
      if (current) setActiveSection(current);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(sectionId);
      setIsMobileMenuOpen(false); // Close mobile menu after navigation
    }
  };

  return (
    <header className={`bg-background/95 backdrop-blur-sm border-b border-slate-200/60 sticky top-0 z-50 transition-all ${
      isScrolled ? 'shadow-sm' : ''
    }`}>
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-5">
        <div className="flex items-center justify-between">
          <div 
            className="flex items-center gap-3 cursor-pointer"
            onClick={() => scrollToSection('hero')}
          >
            <img 
              src="/amadatechnology_logo.jpeg" 
              alt="Amada Technology Logo" 
              className="h-8 w-8 object-contain"
            />
            <span className="text-lg font-semibold text-text-primary">
              Amada Technology
            </span>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('hero')}
              className={`text-sm text-text-secondary hover:text-text-primary transition-colors relative ${
                activeSection === 'hero' ? 'text-text-primary' : ''
              }`}
            >
              Home
              {activeSection === 'hero' && (
                <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-accent"></span>
              )}
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className={`text-sm text-text-secondary hover:text-text-primary transition-colors relative ${
                activeSection === 'services' ? 'text-text-primary' : ''
              }`}
            >
              Services
              {activeSection === 'services' && (
                <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-accent"></span>
              )}
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className={`text-sm text-text-secondary hover:text-text-primary transition-colors relative ${
                activeSection === 'about' ? 'text-text-primary' : ''
              }`}
            >
              About
              {activeSection === 'about' && (
                <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-accent"></span>
              )}
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="border border-accent/30 text-text-primary px-4 py-2 text-sm font-medium hover:bg-soft-surface transition-colors"
            >
              Contact
            </button>
          </nav>

          {/* Mobile Hamburger Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden flex flex-col justify-center items-center w-8 h-8 space-y-1.5"
            aria-label="Toggle menu"
          >
            <span className={`block h-0.5 w-6 bg-text-primary transition-all duration-300 ${
              isMobileMenuOpen ? 'rotate-45 translate-y-2' : ''
            }`}></span>
            <span className={`block h-0.5 w-6 bg-text-primary transition-all duration-300 ${
              isMobileMenuOpen ? 'opacity-0' : ''
            }`}></span>
            <span className={`block h-0.5 w-6 bg-text-primary transition-all duration-300 ${
              isMobileMenuOpen ? '-rotate-45 -translate-y-2' : ''
            }`}></span>
          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
          isMobileMenuOpen ? 'max-h-96 opacity-100 mt-4' : 'max-h-0 opacity-0'
        }`}>
          <nav className="flex flex-col space-y-4 pb-4 border-t border-slate-200/60 mt-4 pt-4">
            <button 
              onClick={() => scrollToSection('hero')}
              className={`text-left text-base text-text-secondary hover:text-text-primary transition-colors py-2 ${
                activeSection === 'hero' ? 'text-text-primary font-medium' : ''
              }`}
            >
              Home
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className={`text-left text-base text-text-secondary hover:text-text-primary transition-colors py-2 ${
                activeSection === 'services' ? 'text-text-primary font-medium' : ''
              }`}
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className={`text-left text-base text-text-secondary hover:text-text-primary transition-colors py-2 ${
                activeSection === 'about' ? 'text-text-primary font-medium' : ''
              }`}
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="text-left text-base border border-accent/30 text-text-primary px-4 py-2 font-medium hover:bg-soft-surface transition-colors w-fit"
            >
              Contact
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
